export const ROUTES = {
  AUTH: {
    UNAUTHORIZED: '/unauthorized',
  },
  HOME: '/',
  DASHBOARD: '/dashboard',
} as const;

// Type for routes
export type AppRoutes = typeof ROUTES; 